import { render, staticRenderFns } from "./ForgotView.vue?vue&type=template&id=271e29c3&scoped=true"
import script from "./ForgotView.vue?vue&type=script&lang=js"
export * from "./ForgotView.vue?vue&type=script&lang=js"
import style0 from "./ForgotView.vue?vue&type=style&index=0&id=271e29c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e29c3",
  null
  
)

export default component.exports